module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/assessment_achievements/1_0a7e5e74c4c48001010872c6fa744a03.png";